module.exports = __webpack_public_path__ + "img/star-inactive.dbf37492.svg";